// @ngInject
Models.FileBlocksCollection = function FileBlocksCollection(BaseCollection) {

    return Class(BaseCollection, {
            constructor: function constructor() {
                this.constructor.$super.call(this);
                this._collection.__className = 'FileBlocksCollection';
                this._collection.__childsType = 'FileBlockModel';
                this._collection.shouldMergeOnLoad = true;
                return this._collection;
            }
        }
    );
};